import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { RiDashboardLine } from "react-icons/ri";
import { TbFilePencil } from "react-icons/tb";
import { GrDocumentUpload } from "react-icons/gr";
import { TbReportAnalytics } from "react-icons/tb";

const TeacherMenu = (props) => {
    const navigate = useNavigate();
    return (
        <>
            <div onClick={() => navigate("/TeacherDashboard", { replace: true })}
                className={props.CheckPath("/StudentInformation") || props.CheckPath("/ViewAnswerSheet") ||
                    props.CheckPath("/LoPerformanceReport") ? "TabNotSelect" : "SubTabSelect"} >
                <RiDashboardLine /> Dashboard </div>

            <div onClick={() => navigate("/TeacherDashboard/StudentInformation/StudentDetails")}
                className={props.CheckPath("StudentDetails") ? "SubTabSelect" : "TabNotSelect"} >
                <TbFilePencil />  Registrations
            </div>

            <div onClick={() => navigate("/TeacherDashboard/StudentInformation/AutobulkRegistrations")}
                className={props.CheckPath("/TeacherDashboard/StudentInformation/AutobulkRegistrations")
                    ? "SubTabSelect" : "TabNotSelect"} >
                <GrDocumentUpload /> Bulk Registrations
            </div>

            <div onClick={() => navigate("/TeacherDashboard/StudentInformation/Results/AssessmentResults")}
                className={props.CheckPath("/Results") || props.CheckPath("/ViewAnswerSheet") || props.CheckPath("/LoPerformanceReport")
                    ? "SubTabSelect" : "TabNotSelect"} >
                <TbReportAnalytics />  Results </div>

            <div onClick={() => navigate("/TeacherDashboard/StudentInformation/AttendanceResults/AttendanceReport")}
                className={props.CheckPath("AttendanceReport") ? "SubTabSelect" : "TabNotSelect"} >
                <TbFilePencil /> Attendance Report </div>
        </>
    )
}
export default TeacherMenu;